import { notifyAccountSwitch } from 'connectors/bugsnag';

export const clearLocalStorageData = (accountData, authentication) => {
  const currentRma = JSON.parse(localStorage.getItem('current-rma'));
  const shoppingCart = JSON.parse(localStorage.getItem('shoppingCart'));

  const hasQuoteUnsavedChanges = JSON.parse(localStorage.getItem('current-quote-modification'));

  localStorage.removeItem('current-rma');
  localStorage.removeItem('shoppingCart');
  localStorage.setItem('current-quote-modification', false);

  //Notify Bugsnag
  notifyAccountSwitch({
    initialAccountId: authentication.endCustomerAccountId,
    finalAccountId: accountData.accountId,
    shoppingCart,
    hasQuoteUnsavedChanges,
    currentRma,
  });
};
